import { Component, OnInit } from "@angular/core";

@Component({
  selector: "gdp-dashboard-container",
  templateUrl: "./dashboard-container.component.html",
  styleUrls: ["./dashboard-container.component.scss"]
})
export class DashboardContainerComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
